import React from "react";
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';

const styles = theme => ({
    statusMessage_Area: {
        width: "100%",
        //height: "260px",
        height: "170px",
        marginLeft: "5px"
    },
    button_edit: {
        float: "right",
        height: "100%",
        color: "white",
        backgroundColor: "#4EDE80",
        '&:hover': {
            backgroundColor: "#8AD68A",
        },
        borderRadius: "0px 0px 0px 0px"
    },
    button_finish: {
        float: "right",
        height: "100%",
        color: "white",
        backgroundColor: "#F48FB1",
        '&:hover': {
            backgroundColor: "#FBB5CC",
        },
        borderRadius: "0px 0px 0px 0px"
    }
});

class StatusMessageArea extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            //入力状態のフラグ
            //true : 入力可
            //false: 入力不可
            inputAvailabilityFlag: false,
        };
    }

    render() {
        const { classes, selectedInterruptedCauseMemo, memoInputAvailabilityFlag } = this.props;
        return (
            <React.Fragment>
                <Grid item xs={10} md={10} lg={10}>
                    <TextField
                        className={classes.statusMessage_Area}
                        disabled={!memoInputAvailabilityFlag}
                        value={selectedInterruptedCauseMemo}
                        multiline
                        onChange={this.props.handleChangeInputStatusMessage}
                        minRows={8}
                        maxRows={8}
                    >
                    </TextField>
                </Grid>
                <Grid item xs={2} md={2} lg={2}>
                    {/* 編集ボタン*/}
                    <Button variant="contained" onClick={() => this.props.changeAvailabilityFlag()} className={(!memoInputAvailabilityFlag) ? classes.button_edit : classes.button_finish} size="large">
                        {(!memoInputAvailabilityFlag) ? "メモ" : "決定"}
                    </Button>
                </Grid>
            </React.Fragment>
        );
    }
}

StatusMessageArea.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(StatusMessageArea);